import {RootActionType} from '@common/actions/RootAction';
import {commonSlice} from '@common/reducer/CommonReducers';
import {tableSlice} from '@common/reducer/TableReducer';
import {authSlice} from '@components/Auth/reducer/AuthReducer';
import {pagingSortingGridSlice} from '@eon.cz/apollo13-frontend-common/lib/components/grid/PagingSortingGridReducer';
import {notificationsSlice} from '@eon.cz/apollo13-frontend-common/lib/notification/reducer/NotificationsReducer';
import {combineReducers, configureStore, PayloadAction} from '@reduxjs/toolkit';
import {useDispatch, useSelector, useStore} from 'react-redux';
import {Store} from '../modules/common/store/Store';
import {zadostiSlice} from '../modules/Zadosti/Sop/reducer/ZadostiReducer';

const rootReducer = (store: Store | undefined, action: PayloadAction<any>) => {
    // combine all reducers
    const combined = combineReducers({
        auth: authSlice.reducer,
        pagingSortingGrid: pagingSortingGridSlice.reducer,
        notifications: notificationsSlice.reducer,
        table: tableSlice.reducer,
        common: commonSlice.reducer,
        zadosti: zadostiSlice.reducer,
    });

    if (action.type === RootActionType.LOGOUT) {
        // Reset store with passing state of undefined
        return combined(undefined, action);
    }

    // Go normal
    return combined(store, action);
};

export const makeStore = () => {
    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['notifications/addNotification'],
                    ignoreActionPaths: ['notifications.notifications'],
                    isSerializable: () => true,
                },
            }),
    });
};

const store = makeStore();

export type RootStore = ReturnType<typeof makeStore>;
export type AppDispatch = RootStore['dispatch'];

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<Store>();
export const useAppStore = useStore.withTypes<RootStore>();

export default store;
